import './review-slider.scss';
import Swiper from 'swiper/bundle';

class ReviewSlider {
    constructor($element) {
        this.$reviewsliderRoot = $element;
        this.$reviewSlider = this.$reviewsliderRoot.querySelector('.swiper');
        this.$slides = this.$reviewsliderRoot.querySelectorAll('.swiper-slide');
        this.slider = [];
    }

    initialize() {
        if (this.$slides.length > 1) {
            this.initSlider();
            this.setEvents();
        }
    }

    initSlider() {
        this.slider = new Swiper(this.$reviewSlider, {
            loop: true,
            preventClicksPropagation: true,
            navigation: {
                nextEl: '.review-slider__swiper-button-next',
                prevEl: '.review-slider__swiper-button-prev'
            },
            initAttr: 'data-review-slider',
            on: {
                init: (swiper) => this.updateSlideIndices(swiper, this)
            },
            effect: 'creative',
            creativeEffect: {
                prev: {
                    translate: [0, 0, -800],
                    rotate: [180, 0, 0]
                },
                next: {
                    translate: [0, 0, -800],
                    rotate: [-180, 0, 0]
                }
            }
        });
    }

    updateSlideIndices(swiper, ctx) {
        const activeSlide = swiper.realIndex + 1;
        const totalSlides = swiper.slides.length - 2;

        const activeSpans = ctx.$reviewsliderRoot.querySelectorAll(
            'span[data-active-slide]'
        );
        if (activeSpans) {
            [].slice.call(activeSpans).forEach((activeSpan) => {
                activeSpan.innerHTML = `${activeSlide}`;
            });
        }

        const totalSpans = ctx.$reviewsliderRoot.querySelectorAll(
            'span[data-total-slides]'
        );
        if (totalSpans) {
            [].slice.call(totalSpans).forEach((totalSpan) => {
                totalSpan.innerHTML = `${totalSlides}`;
            });
        }
    }

    setEvents() {
        this.slider.on('realIndexChange', (swiper) =>
            this.updateSlideIndices(swiper, this)
        );
    }
}

export { ReviewSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $reviewSliders = $context.querySelectorAll(
            '[data-review-slider="root"]'
        );
        if ($reviewSliders.length > 0) {
            for (let i = 0; i < $reviewSliders.length; i++) {
                const $reviewSlider = new ReviewSlider($reviewSliders[i]);
                $reviewSlider.initialize();
            }
        }
    }
});
